export default async (context, footer_status = true) => {
    await context.text_player_default()
    let text = document.getElementById('add-text-page__textarea')
    if(footer_status) {
        await text.blur()
    }
    context.pickColorsMarginBottom = 0
    context.selectColorStatus = false
    context.footerStatus = footer_status
}